import { useCallback, useState } from 'react';
import { array } from 'fp-ts';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { Button } from '@optimus-web/core';
import { AvailabilityBlock } from '@mews-commander/data-access';
import { primitiveTypeUniq } from '@mews/fp';
import { ModalSidePanel } from '@mews-commander/ui';
import { useCommanderSelector, useCommanderThunkDispatch } from '@mews-commander/utils';
import { showReservationGroupDetail } from '../../../actions/availabilityBlock';
import { ReservationGroupData, getAvailabilityBlockGroupData } from '../../../selectors';
import { AvailabilityBlockGroupsTable } from '../tables/AvailabilityBlockGroupsTable';

interface ShowPickupButtonProps {
    availabilityBlock: AvailabilityBlock;
}

const getGroupIds = array.map(({ groupId }: ReservationGroupData) => groupId);
const ShowPickupButton = ({ availabilityBlock }: ShowPickupButtonProps) => {
    const { id: availabilityBlockId } = availabilityBlock;

    const [isOpened, setOpened] = useState(false);

    const dispatch = useCommanderThunkDispatch();
    const openGroup = useCallback(
        (groupId: string) => {
            setOpened(false);
            dispatch(
                showReservationGroupDetail({
                    groupId,
                })
            );
        },
        [dispatch]
    );

    const groupedTableData = useCommanderSelector((s) => getAvailabilityBlockGroupData(s, { availabilityBlockId }));

    const groupIds = primitiveTypeUniq([
        ...getGroupIds(groupedTableData.inhouse),
        ...getGroupIds(groupedTableData.future),
        ...getGroupIds(groupedTableData.past),
        ...getGroupIds(groupedTableData.canceled),
    ]);
    if (!groupIds.length) {
        return null;
    }

    const handleClick = () => {
        if (groupIds.length > 1) {
            setOpened(true);
        } else {
            openGroup(groupIds[0]);
        }
    };

    return (
        <>
            <ModalSidePanel
                opened={isOpened}
                title={<LocalizedText textKey={TextKey.PickedUpReservations} />}
                onClose={() => setOpened(false)}
                content={<AvailabilityBlockGroupsTable groupedTableData={groupedTableData} openGroup={openGroup} />}
                width="medium"
                actions={null}
                headerActions={null}
            />
            <Button onClick={handleClick} data-test-ab-show-pick-up variant="primary" type="submit">
                <LocalizedText textKey={TextKey.View} />
            </Button>
        </>
    );
};

export default ShowPickupButton;
